// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"011ed785","453":"0c5f4479","716":"c0ff56b5","770":"a481088d","974":"82ab0b2f"}[chunkId] + ".chunk.js";
};